<template>
  <div v-if="meta" class="supervision-banner" role="status">
    <span>
      Modo supervisión: estás viendo la app como
      <strong>{{ currentUserName }}</strong>
      (supervisor: {{ meta.supervisor_name }})
    </span>
    <ion-button size="small" fill="solid" color="light" @click="exit">Salir</ion-button>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { IonButton } from '@ionic/vue';
import userAuth from '@/composables/userAuth';

const meta = computed(() => {
  const raw = localStorage.getItem('supervision');
  if (!raw) return null;
  try {
    return JSON.parse(raw) as { supervisor_name?: string };
  } catch {
    return null;
  }
});

const currentUserName = computed(() => {
  try {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    return user?.name || 'usuario';
  } catch {
    return 'usuario';
  }
});

function exit(): void {
  userAuth().logout();
}
</script>

<style scoped>
.supervision-banner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 8px 14px;
  background: #b45309;
  color: #fffbeb;
  font-size: 0.85rem;
  line-height: 1.35;
  z-index: 10000;
}
</style>
